import {
  GreeksFeesMetricsDispatchProps,
  GreeksFeesMetricsStateProps,
} from 'components/common-form/sidePanel/info/QuoteInfos/GreeksFeesMetricsTabContent/GreeksFeesMetricsTabContent.connect';
import { connect } from 'react-redux';
import { addonSelector, getUserPreferencesGreeksPrecision } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { toggleQuoteInfosSection } from 'state/uiPanelState/quoteDetail/quoteDetail.action';
import { collapsedSections } from 'state/uiPanelState/quoteDetail/quoteDetail.selector';

interface OwnProps {
  tabId: string;
}

const mapStateToProps = (state: AppState, { tabId }: OwnProps): GreeksFeesMetricsStateProps => {
  const sections = collapsedSections(state, tabId);
  const quoteDetails = addonSelector.getQuoteDetails(state, tabId);
  const hasFees = addonSelector.hasFees(state, tabId);
  const hasGreeks = addonSelector.hasGreeks(state, tabId);
  const hasMetrics = addonSelector.hasMetrics(state, tabId);
  const hasHistoricalAverageCorrelations = addonSelector.hasHistoricalAverageCorrelations(state, tabId);
  const hasPrices = addonSelector.hasPrices(state, tabId);
  const hasProductGreeks = addonSelector.hasProductGreeks(state, tabId);

  return {
    collapsedSections: sections,
    hasFees,
    hasGreeks,
    hasMetrics,
    hasHistoricalAverageCorrelations,
    hasPrices,
    hasProductGreeks,
    ficcGreeks: quoteDetails?.FICCGreeks,
    greeks: quoteDetails?.Greeks,
    precisionGreeks: getUserPreferencesGreeksPrecision(state) ?? 4,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): GreeksFeesMetricsDispatchProps => {
  return {
    toggleSectionVisibility: section => {
      dispatch(toggleQuoteInfosSection(tabId, section));
    },
  };
};

export const connectGreeksFeesMetricsTabContentController = connect(mapStateToProps, mapDispatchToProps);
